/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect } from "react";
import classes from "./detail.module.css";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import { withTranslation } from "react-i18next";
// import TextEditor from "../../../../component/richTextEditor";
import TiptapEditor from "../../../../component/richTextEditor/TiptapEditor";
import {
  EditorState,
  ContentState,
  convertToRaw,
  convertFromRaw,
  Modifier,
} from "draft-js";
import createPackageClasses from '../../../pm/packagedSolution/createPackage.module.css';

const Detail = (props) => {
  const [value, setValue] = React.useState(0);
  const [color, setColor] = React.useState("");
  useEffect(() => {
    setColor(props.tenantData.color.trim() + "60");
  }, []);

  // const setEditorState = (data) => {
  //   var initialData = JSON.parse(data);
  //   var finalData = convertFromRaw(initialData);
  //   return EditorState.createWithContent(finalData);
  // };
  return (
    <div style={{ width: "100%" }}>
      <Tabs
        // classes={{
        //   root: classes.tabsRoot,
        //   indicator: classes.activeTabIndicator,
        // }}
        value={value}
        onChange={(e, newValue) => {
          setValue(newValue);
        }}
        indicatorColor="primary"
        className={createPackageClasses.createPackageTabs}
      >
        <Tab
          value={0}
          label={props.t("OVERVIEW")}
        />
        <Tab
          value={1}
          label={props.t("TECH_SPECS")}
        />
        {props.whatsIncluded &&
          JSON.parse(props.whatsIncluded).blocks[0].text && (
            <Tab
              value={2}
              label={props.t("WHAT_IS_INCLUDED")}
            />
          )}
      </Tabs>
      <div className={classes.contentWrapper}>
        {value === 0 && (
          // props.noOverview ?
          // props.t('NO_OFFERING_OVERVIEW')
          // :
          <TiptapEditor
            value={props.overView}
            readOnly={true}
          />
        )}
        {value === 1 && (
          // props.noTechspecs ?
          // props.t('NO_OFFERING_TECHSPECS')
          // :
          <TiptapEditor
            value={props.techSpecs}
            readOnly={true}
          />
        )}
        {value === 2 && (
          // props.noWhatsincluded ?
          // props.t('NO_OFFERING_WHATSINCLUDED')
          // :
          <TiptapEditor
            value={props.whatsIncluded}
            readOnly={true}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    id_token: state.auth.id_token,
    tenantData: state.auth.tenantData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(Detail));
